import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Card from '@material-ui/core/Card';
import Skeleton from '@material-ui/lab/Skeleton';

const ItemCardSkeleton = ({ mediaSize }) => (
  <Card>
    <Box display="flex" alignItems="flexStart" justifyContent="flexStart">
      <Skeleton variant="rect" height={mediaSize} width={mediaSize} />
      <Box p={1} flex={1}>
        <Skeleton height={36} />
        <Box mt={1}>
          <Skeleton />
          <Skeleton />
        </Box>
      </Box>
    </Box>
  </Card>
);

ItemCardSkeleton.propTypes = {
  mediaSize: PropTypes.number,
};

ItemCardSkeleton.defaultProps = {
  mediaSize: 150,
};

export default ItemCardSkeleton;
